import React from 'react';
import { Star } from 'lucide-react';

export const StarRating = ({ value = 5, size = 14, className = '' }) => (
  <div className={`inline-flex items-center gap-0.5 ${className}`}>
    {[1,2,3,4,5].map((n) => (
      <Star
        key={n}
        size={size}
        className={n <= Math.round(value) ? 'text-[hsl(var(--sb-gold))]' : 'text-white/15'}
        fill={n <= Math.round(value) ? 'currentColor' : 'none'}
      />
    ))}
  </div>
);

// Google "G" glyph in brand colours (no external dependency)
const GoogleGlyph = ({ size = 14 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.85 0-5.27-1.93-6.13-4.52H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#FBBC05" d="M5.87 14.11c-.22-.66-.35-1.36-.35-2.11s.13-1.45.35-2.11V7.05H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.95l3.69-2.84z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.05l3.69 2.84C6.73 7.31 9.15 5.38 12 5.38z"/>
  </svg>
);

export const ReviewCard = ({ review }) => (
  <div className="sb-card p-5 h-full flex flex-col">
    <div className="flex items-center justify-between">
      <div>
        <div className="font-semibold text-white">{review.customer_name}</div>
        <StarRating value={review.rating} className="mt-0.5" />
      </div>
      <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-semibold px-2 py-1 rounded-full bg-white text-[#3c4043]">
        <GoogleGlyph size={12} /> Google
      </span>
    </div>
    <p className="text-sm text-white/80 mt-3 flex-1">&ldquo;{review.text}&rdquo;</p>
    {review.date && <div className="text-[11px] text-white/45 mt-3">{review.date}</div>}
  </div>
);

export { GoogleGlyph };
